import { render, staticRenderFns } from "./MenuGrafitex.vue?vue&type=template&id=004626cb&scoped=true"
import script from "./MenuGrafitex.vue?vue&type=script&lang=js"
export * from "./MenuGrafitex.vue?vue&type=script&lang=js"
import style0 from "./MenuGrafitex.vue?vue&type=style&index=0&id=004626cb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "004626cb",
  null
  
)

export default component.exports